<script setup>
import { ref } from 'vue';
import { useStore } from 'dashboard/composables/store';
import { useI18n } from 'vue-i18n';
import { useAlert } from 'dashboard/composables';

import Dialog from 'dashboard/components-next/dialog/Dialog.vue';

const emit = defineEmits(['deleted']);
const { t } = useI18n();
const store = useStore();

const dialogRef = ref(null);
const campaignToDelete = ref(null);

const open = campaign => {
  campaignToDelete.value = campaign;
  dialogRef.value?.open();
};

const props = defineProps({
  storeModule: {
    type: String,
    default: 'campaigns',
  },
});

const deleteCampaign = async id => {
  if (!id) {
    return false;
  }

  try {
    await store.dispatch(`${props.storeModule}/delete`, id);
    useAlert(t('CAMPAIGN.CONFIRM_DELETE.API.SUCCESS_MESSAGE'));
    return true;
  } catch (error) {
    useAlert(t('CAMPAIGN.CONFIRM_DELETE.API.ERROR_MESSAGE'));
    return false;
  }
};

const handleDialogConfirm = async () => {
  const deleted = await deleteCampaign(campaignToDelete.value?.id);
  dialogRef.value?.close();
  if (deleted) {
    emit('deleted');
  }
  campaignToDelete.value = null;
};

defineExpose({ open });
</script>

<template>
  <Dialog
    ref="dialogRef"
    type="alert"
    :title="t('CAMPAIGN.CONFIRM_DELETE.TITLE')"
    :description="t('CAMPAIGN.CONFIRM_DELETE.DESCRIPTION')"
    :confirm-button-label="t('CAMPAIGN.CONFIRM_DELETE.CONFIRM')"
    @confirm="handleDialogConfirm"
  />
</template>
